module.exports = __webpack_public_path__ + "img/T5-B-rc15.7309786b.png";